import React from "react";
import { IMAGE_URL, SITE_URL } from "../../constants";
import { Link } from "react-router-dom";

const HomeDepartmentBtnSectionMobile = ({
  departments,
  banners,
  findADoctorPopupClicked,
  bookAppointmentPopupClicked,
  setDepartments,
  setBanners,
  setFindADoctorPopupClicked,
  setBookAppointmentPopupClicked,
}) => {
  return (
    <div>
      <div
        className="col-12 d-flex flex-column justify-content-center align-items-center mt-4 d-md-none"
        style={{ maxWidth: "100%" }}
      >
        <div
          className="d-flex flex-row justify-content-between align-items-center mt-3 p-2 w-100 gap-3 overflow-auto pt-3"
          style={{
            backgroundColor: "#FFFFFF",
            borderRadius: "5px",
          }}
        >
          {departments.length > 0
            ? departments.slice(0, 6).map((banner_button) => {
                let buttonSlug = banner_button.department_name
                  .replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\\/]/gi, "")
                  .replace(/\s+/g, "-")
                  .replace(/-$/, "")
                  .toLowerCase();

                return (
                  <div className="p-0 department-menu">
                    <a
                      href={SITE_URL + "/departments/" + buttonSlug}
                      style={{ textDecoration: "none" }}
                    >
                      <div
                        className="card cardHover"
                        style={{
                          width: "100%",
                          margin: "0 auto",
                          height: "45px",
                          display: "flex",
                          justifyContent: "center",
                          borderRadius: "5px",
                          backgroundColor: "#F7F5EF",
                          // color: "#AF9763",
                          fontWeight: "500",
                        }}
                      >
                        <div
                          className="p-2 d-flex justify-content-center align-items-center w-100"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <div className="">
                            {banner_button.banner_btn_icon ? (
                              <img
                                // className="ql-background"
                                src={
                                  IMAGE_URL +
                                  "BannerButtonImg/" +
                                  banner_button.banner_btn_icon
                                }
                                alt="avtars"
                                style={{
                                  borderRadius: "50%",
                                  width: "100%",
                                  maxWidth: "27px",
                                }}
                              />
                            ) : (
                              <i className="fa-solid fa-circle-right"></i>
                            )}
                          </div>

                          <p className="px-2">
                            {banner_button.banner_btn_text}
                          </p>
                        </div>
                      </div>
                    </a>
                  </div>
                );
              })
            : ""}
          <div className="p-0 department-menu d-none d-lg-block">
            <Link
              className="d-inline-block w-100"
              style={{ textDecoration: "none" }}
              to={"/pages/departments"}
            >
              <div
                className="card "
                style={{
                  width: "100%",
                  margin: "0 auto",
                  height: "45px",
                  display: "flex",
                  justifyContent: "center",
                  borderRadius: "5px",
                  backgroundColor: "#AF9763",
                  color: "#ffffff",
                  fontWeight: "500",
                }}
              >
                <button
                  style={{
                    padding: "11px",
                    color: "#fff",
                    textTransform: "capitalize",
                    border: "none",
                    backgroundColor: "transparent",
                    borderRadius: "6px",
                    fontWeight: "500",
                    width: "100%",
                  }}
                  className="deptBtnFont"
                >
                  View All Departments
                </button>
              </div>
            </Link>
          </div>
        </div>
      </div>
      <div className="col-12 d-flex justify-content-center align-items-center mb-2 w-100  d-md-none">
        <div
          className="py-3 department-menu d-block d-lg-none w-100 text-center"
          style={{
            backgroundColor: "#ffffff",
            borderBottomRightRadius: "5px",
            borderBottomLeftRadius: "5px",
          }}
        >
          <Link
            className="d-inline-block w-50"
            style={{ textDecoration: "none" }}
            to={"/pages/departments"}
          >
            <div
              className="card "
              style={{
                width: "100%",
                margin: "0 auto",
                height: "45px",
                display: "flex",
                justifyContent: "center",
                borderRadius: "5px",
                backgroundColor: "#AF9763",
                color: "#ffffff",
                fontWeight: "500",
              }}
            >
              <button
                style={{
                  padding: "11px",
                  color: "#fff",
                  textTransform: "capitalize",
                  border: "none",
                  backgroundColor: "transparent",
                  borderRadius: "6px",
                  fontWeight: "500",
                  width: "100%",
                }}
                className="deptBtnFont"
              >
                View All Departments
              </button>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default HomeDepartmentBtnSectionMobile;



// WEBPACK FOOTER //
// ./src/component/frontend/HomeDepartmentBtnSectionMobile.js